import { PATH } from '../routes/constant'
import dataRepository from './dataRepository'
import { LOCAL_STORAGE } from './constants/localStorage'

export const isPathLogged = (str: string) => {
  const arr = Object.values(PATH)

  for (let i = 0; i < arr.length; i++) {
    const element = arr[i]

    if (typeof element === 'function') {
      const params = JSON.parse(String(dataRepository.getData(LOCAL_STORAGE.PARAMS)))
      if (element.apply(null, params) === str) {
        return true
      }
      continue
    }
    if (element === str) {
      return true
    }
  }

  return false
}
